(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/payfooter.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/payfooter.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Default extends svs.tur.Base {
  constructor(_ref) {
    var _svs$tur$ab_tests;
    let _ref$sum = _ref.sum,
      sum = _ref$sum === void 0 ? null : _ref$sum,
      _ref$balance = _ref.balance,
      balance = _ref$balance === void 0 ? null : _ref$balance,
      _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? [] : _ref$text,
      _ref$autoReminder = _ref.autoReminder,
      autoReminder = _ref$autoReminder === void 0 ? false : _ref$autoReminder,
      reminderOptions = _ref.reminderOptions,
      _ref$calculateParent = _ref.calculateParent,
      calculateParent = _ref$calculateParent === void 0 ? '' : _ref$calculateParent,
      _ref$calculateParentE = _ref.calculateParentElements,
      calculateParentElements = _ref$calculateParentE === void 0 ? svs.tur.payfooter.PARENT_ELEMENTS : _ref$calculateParentE;
    super({
      sum,
      balance,
      buttons,
      text,
      autoReminder,
      calculateParent,
      calculateParentElements
    });
    this._elements = [];
    this.createDomElements();
    this.$el.classList += ' dots dots-tur grid-row';
    if (sum) {
      this.trigger(svs.tur.payfooter.SUM_UPDATED, {
        amount: sum.amount,
        animate: false
      });
    }
    if (balance) {
      this.trigger(svs.tur.payfooter.BALANCE_UPDATED, {
        amount: balance.amount,
        animate: false
      });
    }
    if (calculateParent && calculateParentElements) {
      this.parentHeightAttach();
    }
    const abTestVersion = (_svs$tur$ab_tests = svs.tur.ab_tests) === null || _svs$tur$ab_tests === void 0 ? void 0 : _svs$tur$ab_tests.data.PayfooterReminder;
    if (abTestVersion === 'A') {
      this.reminder = new svs.tur.payfooter_reminder(reminderOptions);
    } else {
      this.reminder = new svs.tur.payfooter_reminder_button_counter(_objectSpread(_objectSpread({}, reminderOptions), {}, {
        source: this
      }));
    }
  }
  createDomElements() {
    this.$inner = this.createElement('payfooter-inner');
    if (this.balance) {
      if (typeof this.balance.addEventHandler === 'function') {
        this.balance.addEventHandler(this);
      }
      this.append(this.balance.render());
    }
    if (this.sum) {
      if (typeof this.sum.addEventHandler === 'function') {
        this.sum.addEventHandler(this);
      }
      this.append(this.sum.render());
    }
    if (this.buttons.length) {
      for (let i = 0; i < this.buttons.length; i++) {
        const btn = this.buttons[i];
        if (typeof btn.addEventHandler === 'function') {
          btn.addEventHandler(this);
        }
        this.$inner.appendChild(btn.$el);
        this._elements.push(btn.$el);
      }
    }
    this.updateText();
    this.$el.appendChild(this.$inner);
  }
  append(el) {
    if (el) {
      this.$inner.appendChild(el);
      this._elements.push(el);
    }
  }
  classNames() {
    const classes = ['payfooter', 'js-payfooter', 'payfooter-default'];
    if (this.calculateParent && this.calculateParent !== 'undefined') {
      classes.push('payfooter-bottom');
    }
    return classes;
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!visible) {
      this.$el.style.opacity = 0;
    }
    return this.$el;
  }
  animate() {
    const tl = gsap.timeline({
      delay: 0.1
    });
    tl.fromTo(this.$el, {
      opacity: 0
    }, {
      duration: 0.2,
      opacity: 1,
      clearProps: 'all'
    });
    for (let i = 0; i < this._elements.length; i++) {
      const el = this._elements[i];
      tl.fromTo(el, {
        opacity: 0,
        scale: 0.8
      }, {
        duration: 0.2,
        opacity: 1,
        scale: 1,
        clearProps: 'all'
      }, '-=.15');
    }
    return tl;
  }
  updateSum(_ref2) {
    let _ref2$amount = _ref2.amount,
      amount = _ref2$amount === void 0 ? 0 : _ref2$amount,
      _ref2$animate = _ref2.animate,
      animate = _ref2$animate === void 0 ? true : _ref2$animate,
      _ref2$text = _ref2.text,
      text = _ref2$text === void 0 ? '' : _ref2$text;
    this._sum = amount;
    this.trigger(svs.tur.payfooter.SUM_UPDATED, {
      amount,
      animate,
      text
    });
    if (animate && this.autoReminder) {
      this.showReminder();
    }
  }
  updateBalance(_ref3) {
    let _ref3$amount = _ref3.amount,
      amount = _ref3$amount === void 0 ? 0 : _ref3$amount,
      _ref3$animate = _ref3.animate,
      animate = _ref3$animate === void 0 ? true : _ref3$animate,
      _ref3$text = _ref3.text,
      text = _ref3$text === void 0 ? '' : _ref3$text,
      forceDim = _ref3.forceDim;
    this._balance = amount;
    this.trigger(svs.tur.payfooter.BALANCE_UPDATED, {
      amount,
      animate,
      text,
      forceDim
    });
    if (animate && this.autoReminder) {
      this.showReminder();
    }
  }
  updateText() {
    let _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        text: this.text
      },
      _ref4$text = _ref4.text,
      text = _ref4$text === void 0 ? this.text : _ref4$text;
    const paragraphClass = 'payfooter-text';
    const nodesToDelete = this.$inner.getElementsByClassName(paragraphClass);
    for (let i = 0; i < nodesToDelete.length; i++) this.$inner.removeChild(nodesToDelete[i]);
    if (text.length) {
      for (let i = 0; i < text.length; i++) {
        const paragraph = text[i];
        this.$inner.insertAdjacentHTML('beforeend', "<p class=\"".concat(paragraphClass, "\">").concat(paragraph, "</p>"));
      }
    }
  }
  showReminder() {
    let leaveReminder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!this.inViewPort()) {
      this.reminder.show(null, leaveReminder);
    }
  }
  hideReminder() {
    this.reminder.hide();
  }
  destroyReminder() {
    var _svs$tur$ab_tests$dat;
    if (((_svs$tur$ab_tests$dat = svs.tur.ab_tests.data) === null || _svs$tur$ab_tests$dat === void 0 ? void 0 : _svs$tur$ab_tests$dat.PayfooterReminder) === 'B') {
      this.reminder.destroy();
    }
  }
  updateReminderButtonTitle(text) {
    var _svs$tur$ab_tests$dat2;
    if (((_svs$tur$ab_tests$dat2 = svs.tur.ab_tests.data) === null || _svs$tur$ab_tests$dat2 === void 0 ? void 0 : _svs$tur$ab_tests$dat2.PayfooterReminder) === 'B') {
      this.reminder.updateButtonTitle(text.includes('vecka'));
    }
  }
  inViewPort() {
    const bounding = this.$el.getBoundingClientRect();
    const boundingBottomAdjustment = 50;
    return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + boundingBottomAdjustment && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
  }
  parentHeightAttach() {
    window.addEventListener('resize', _.debounce(() => {
      this.parentHeightSet();
    }));
    window.dispatchEvent(new Event('resize'));
  }
  parentHeightSet() {
    const height = this.parentHeightCalculate();
    const targetEl = document.querySelector(this.calculateParent);
    if (height && targetEl) {
      targetEl.style.height = "calc(100vh - ".concat(height, "px");
      targetEl.style.position = 'relative';
    }
  }
  parentHeightCalculate() {
    let totalHeight = 0;
    const parentElements = document.querySelectorAll(this.calculateParentElements);
    for (let i = 0, len = parentElements.length; i < len; i++) {
      totalHeight += parentElements[i].offsetHeight;
    }
    return totalHeight;
  }
}
svs.tur.payfooter.Default = Default;
svs.tur.payfooter.BUTTON_PAY = 'payfooter:button:pay';
svs.tur.payfooter.BUTTON = 'payfooter:button';
svs.tur.payfooter.SUM_UPDATED = 'payfooter:sum:updated';
svs.tur.payfooter.BALANCE_UPDATED = 'payfooter:balance:updated';
svs.tur.payfooter.PARENT_ELEMENTS = ['.js-fixed-top-content', '.tabs-game-navigation', '.games-navigation-wrapper'];

 })(window);